<div style="position: relative;">
    <app-loader [showLoader]=showLoad></app-loader>
    <div *ngIf="displayData">
        <app-carousel [title]='title' [data]="displayData" [slideClassNames]="setSlideClassNames" [placeholderImage]="placeholderimage"></app-carousel>
    </div>
</div>